import { RouteObject } from 'react-router-dom';

import ActionSettings from './ActionSettings';

export const actionsRoute: RouteObject = {
  path: 'actions',
  element: <ActionSettings />,
};
